import { useContext, useEffect, useState } from "react";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import ModalSituation from "../../dialogs/companySituation";
import useModal from "../../../Hooks/useModal";
import useLoading from "../../../Hooks/useLoading";
import ModalEditCompany from "../editCompany";
import { AuthContext } from "../../../Contexts/AuthContext";
import { Button, Typography } from "antd";
import { ClearOutlined, EditOutlined, ExperimentOutlined, EyeInvisibleOutlined, EyeOutlined, RocketOutlined, UserAddOutlined } from "@ant-design/icons";
import './styles.css';
import { AllStatus } from "../../../Utils/AllContratTypes";
import { AllSteps } from "../../../Utils/AllSteps";
import { convertUSDToBRL } from "../../../Utils/USDToBRL";
import { GetCompanyLogo } from "../../../API/CompaniesAPI";

export default function Header() {
    const { loading, toggleLoading } = useLoading();
    const { showModal, toggleShowModal } = useModal();
    const { showModal: showModalCompany, toggleShowModal: toggleShowModalCompany } = useModal();
    const { company, getCompany } = useContext(CompanyContext);
    const { userEmail } = useContext(AuthContext);
    const [see, setSee] = useState<boolean>(true);
    const [imageUrl, setImageUrl] = useState<string>('img/logo-default.png');
    const toggleSee = () => setSee(!see);

    useEffect(() => {
        fetchCompanyLogo();
    }, [company]);

    useEffect(() => {
        console.log("company", company);
    }, []);

    const refreshCompanyData = async () => {
        try {
            toggleLoading(true);
            await getCompany(company.id);
        } catch (error) {
            console.error("Erro ao atualizar dados da empresa:", error);
        } finally {
            toggleLoading(false);
        }
    };

    const fetchCompanyLogo = async () => {
        try {
            if (!company?.id) return;
            const response = await GetCompanyLogo(company.id);
            const contentType = response.headers['content-type'] || 'application/octet-stream';
            const blob = new Blob([response.data], { type: contentType });

            if(blob.size !== 0){
                const fileURL = URL.createObjectURL(blob);
                setImageUrl(fileURL);
            }
        } catch (error) {
            setImageUrl('img/logo-default.png');
        }
    };

    return (
        <div className="header-container">
            {/* Modais */}
            <ModalSituation
                loading={loading}
                toggleLoading={toggleLoading}
                showModal={showModal}
                toggleShowModal={toggleShowModal}
                companyId={company.id}
                userEmail={userEmail}
            />
            <ModalEditCompany
                loading={loading}
                company={company}
                showModal={showModalCompany}
                toggleLoading={toggleLoading}
                toggleShowModal={toggleShowModalCompany}
                userEmail={userEmail}
                getCompany={refreshCompanyData}
                getCompanyLogo={fetchCompanyLogo}
                companyLogoUrl={imageUrl}
            />
            {/* Seção da Imagem */}
            <div className="img-edit-container-header">
                <div className="img-container-header">
                    <img
                        className="img-header"
                        src={imageUrl}
                        alt="logo"
                        onClick={toggleShowModalCompany}
                    />
                </div>
                <Button
                    icon={<EditOutlined />}
                    onClick={toggleShowModalCompany}
                    className="btn-edit-header"
                >
                    Editar
                </Button>
            </div>
            {/* Seção de Informações */}
            <div className="infos-container-header">
                <div className="infos-line-header">
                    <RocketOutlined className="img-infos-line-header" />
                    <Typography className="text-infos-line-header">Nome da Empresa:</Typography>
                    <Typography className="text-variable-infos-line-header">
                        {company.name || "--"}
                    </Typography>
                </div>
                <div className="infos-line-header">
                    <UserAddOutlined className="img-infos-line-header" />
                    <Typography className="text-infos-line-header">CNPJ:</Typography>
                    <Typography className="text-variable-infos-line-header">
                        {company.cnpj ? company.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : "--"}
                    </Typography>
                </div>
                <div className="infos-line-header">
                    <ClearOutlined className="img-infos-line-header" />
                    <Typography className="text-infos-line-header">Tipo de Contrato:</Typography>
                    <Typography className="text-variable-infos-line-header">
                        {company.contractType ? AllStatus[company.contractType]?.label : "--"}
                    </Typography>
                </div>
                <div className="infos-line-header">
                    <ExperimentOutlined className="img-infos-line-header" />
                    <Typography className="text-infos-line-header">Etapa Atual:</Typography>
                    <Typography className="text-variable-infos-line-header">
                        {company.processStep ? AllSteps[company.processStep]?.label : "--"}
                    </Typography>
                </div>
            </div>
            {/* Seção de Valores */}
            <div className="values-container-header">
                <Button
                    className="btn-see-header"
                    onClick={toggleSee}
                    icon={see ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                />
                <div className="values-text-container">
                    <Typography className="values-text-header">Potencial de Financiamento</Typography>
                    <Typography className="values-text-variable-header">
                        {see ? convertUSDToBRL(company.potentialValue?.toFixed(2) || "R$ 0,00") : "R$ --------"}
                    </Typography>
                </div>
                <div className="vl"></div>
                <div className="values-text-container">
                    <Typography className="values-text-header">Valores de Projetos</Typography>
                    <Typography className="values-text-variable-header">
                        {see ? convertUSDToBRL(company.projectsValue?.toFixed(2) || "R$ 0,00") : "R$ --------"}
                    </Typography>
                </div>
            </div>
        </div>
    );
}